// imports react
import React, { useEffect, useState } from "react";

//imports libraries
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import jsPDF from 'jspdf';

//imports components
import styles from "../styles/evokchat.module.css";
import { urlAPI_Current } from "../config";
import axios from "axios";
import { TriangularRadarChart } from "./TriangularRadarChart";

export function UserReportsProfile({userData, darkMode }) {
  const [profileResult, setProfileResult] = useState('');
  const [reportIsReady, setReportIsReady] = useState(false);
  const [remainingTime, setRemainingTime] = useState(null);

  async function getProfileResult() {
    try {
        const response = await axios.post(`${urlAPI_Current}/getProfileResult`, {} , {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('authToken')}`  
          }
        });

        const { perfil } = response.data;
        if (perfil && typeof perfil.htmlContent === 'string') {
          setProfileResult(perfil.htmlContent);
        } else {
          console.error('O conteúdo HTML não é uma string:', perfil);
        }
      } catch (error) {
        console.error('Erro ao buscar o resultado do perfil:', error);
      }
  }

  async function verifyTimeLastAnswer(){
    try {
        const timeLastAnswer = await axios.post(`${urlAPI_Current}/getTimeLastAnswer`, {
            userId: localStorage.getItem('userId') }, 
            { 
            headers: 
                { 'Authorization': `Bearer ${localStorage.getItem('authToken')}` }
            });

            console.log(timeLastAnswer);
        if(timeLastAnswer.data.success == true){
            const lastAnswerDate = new Date(timeLastAnswer.data.dataGerando);
            const relatorioEnviado = timeLastAnswer.data.relatorioEnviado;

            const currentDate = new Date();
            
            // ainda não comecou a gerar o relatório
            if(timeLastAnswer.data.dataGerando == null){
                setRemainingTime(0); 
                return false;
            }
            const diffInMinutes = Math.floor((currentDate - lastAnswerDate) / (1000 * 60));
            
            // se não gerou, ou se tempo não passou 30 min
            if(relatorioEnviado == 0 || diffInMinutes < 30) {
                const minutesRemaining = 30 - diffInMinutes;
                setRemainingTime(diffInMinutes);
                //toast.error(`Por favor, aguarde um momento para processar o relatório`);

                return false;
            } else {
                setReportIsReady(true);
                //toast.success(`Relatório gerado com sucesso!`);
                return true;
            }
        }
    } catch (error) {
        console.log("Erro ao verificar tempo:", error);
        //toast.error("Erro ao verificar tempo de esperaa");
        return false;
    }
  }


  async function downloadFinalReportPdf() {
    try {
      if(reportIsReady == true){
        toast.info('Iniciando download do relatório...');
  
        const response = await axios.post(
          `${urlAPI_Current}/downloadReportPDF`,
          {},
          {
            headers: {
              'Authorization': `Bearer ${localStorage.getItem('authToken')}`
            },
            responseType: 'blob'
          }
        );
    
        // Cria um link temporário para download
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `relatorio-${userData.nome}.pdf`);
        document.body.appendChild(link);
        link.click();
        link.remove();
    
        toast.success('Relatório baixado com sucesso!');
      }
    } catch (error) {
      console.error('Erro ao baixar o PDF:', error);
      toast.error('Relatório não encontrado. Tente novamente');
    }
  }

  useEffect(() => {
    getProfileResult();
    verifyTimeLastAnswer();

    const pollingInterval = setInterval(() => {
        verifyTimeLastAnswer();
    }, 60000); 

    return () => {
        clearInterval(pollingInterval);
    };
  }, []); 

  return (
    <div
      className="card mb-5 mb-xl-10"
      data-bs-theme={darkMode ? "dark" : "light"}
    >
      <div className="card-header">
        <div className="card-title">
          <h3>Seus Relatórios</h3>
        </div>
      </div>

      <div className="card-body">
        <div className="tab-content">
          <div
            id="kt_activity_today"
            className="card-body p-0 tab-pane fade show active"
            role="tabpanel"
            aria-labelledby="kt_activity_today_tab"
          >
             <div className="timeline timeline-border-dashed">
              <div className="timeline-item">
                <div className="timeline-line"></div>

                <div className="timeline-icon">
                  <i className="ki-outline ki-disconnect fs-2 text-gray-500"></i>
                </div>

                <div className="timeline-content mb-10 mt-n1">
                  <div className="mb-5 pe-3">
                    <p
                      href="#"
                      className="fs-5 fw-semibold text-gray-800 text-hover-primary mb-2"
                    >
                      Perfis dimensionais
                    </p>
                  </div>

                  {userData.relatorioEnviado ? (
                      <div className={styles.containerChart}>
                        <TriangularRadarChart />
                      </div>
                    ) : (
                      <p>Você precisa responder o <strong>questionário</strong> primeiro!</p>
                    )}
              </div>
              </div>
              <div className="timeline-item">

              </div>
            </div>
            <div className="timeline timeline-border-dashed">
              <div className="timeline-item">
                <div className="timeline-line"></div>

                <div className="timeline-icon">
                  <i className="ki-outline ki-disconnect fs-2 text-gray-500"></i>
                </div>

                <div className="timeline-content mb-10 mt-n1">
                  <div className="mb-5 pe-3">
                    <p
                      href="#"
                      className="fs-5 fw-semibold text-gray-800 text-hover-primary mb-2"
                    >
                      Seu Perfil
                    </p>
                  </div>

                  <div className="overflow-auto pb-5">
                    {userData.relatorioEnviado ? (
                      <>
                      <div dangerouslySetInnerHTML={{ __html: profileResult }} />
                        <div className="d-flex align-items-center border border-dashed border-gray-300 rounded min-w-700px p-5" style={{cursor: "pointer"}} onClick={() => downloadFinalReportPdf()}>
                        
                          <div className="d-flex flex-aligns-center pe-10 pe-lg-20">
                            <img
                              alt=""
                              className="w-30px me-3"
                              src="assets/media/svg/files/pdf.svg"
                            />

                          {reportIsReady ?
                            <div className="ms-1 fw-semibold">
                              <p
                                href="apps/projects/project.html"
                                className="fs-6 text-hover-primary fw-bold"
                              >
                                relatorio-{userData.nome}.pdf
                              </p>

                              <div className="text-gray-500">64 KB</div>
                            </div>
                          :  <div className="ms-1 fw-semibold">
                              <p
                                href="apps/projects/project.html"
                                className="fs-6 text-hover-primary fw-bold"
                              >
                                  Estamos processando suas informações
                              </p>

                              <div className="text-gray-500">Você poderá baixar seu relatório aqui.</div>
                              <div className="text-gray-500">Tempo percorrido: {remainingTime} minutos</div>
                            </div>
                            }
                          </div>
                        </div>
                      </>
                    ) : (
                      <p>Você precisa responder o <strong>questionário</strong> primeiro!</p>
                    )}
                  
                </div>
              </div>
              </div>
              <div className="timeline-item">

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
